import { z } from "zod";
import { planIntervalSchema } from "./common";

export type { PlanInterval } from "./common";

// --- Entity schemas (API) ---
export const planSchema = z.object({
  publicId: z.string(),
  name: z.string(),
  price: z.number(),
  categoryId: z.number(),
  categoryPublicId: z.string().nullable().optional(),
  interval: planIntervalSchema,
  durationDays: z.number(),
  isCalendarDuration: z.boolean().optional(),
  active: z.boolean(),
  createsSubscription: z.boolean().optional(),
  registersAccessOnSale: z.boolean().default(false),
  classCount: z.number().nullable().optional(),
  kind: z.string().optional(),
  requiredTagPublicIds: z.array(z.string()).default([]),
});
export type Plan = z.infer<typeof planSchema>;

export const plansPaginationSchema = z.object({
  totalCount: z.number().optional().default(0),
  pageCount: z.number().optional().default(0),
  currentPage: z.number(),
  perPage: z.number(),
});

export const planCategorySchema = z.object({
  id: z.number(),
  publicId: z.string(),
  name: z.string(),
  key: z.string(),
  isClassBased: z.boolean(),
});
export type PlanCategory = z.infer<typeof planCategorySchema>;

// --- Form schema ---
export const planFormSchema = z
  .object({
    name: z
      .string()
      .min(1, "El nombre es obligatorio")
      .transform((s) => s.trim())
      .pipe(z.string().min(3, "El nombre debe tener al menos 3 caracteres")),
    categoryId: z.coerce.number().min(1, "Selecciona una categoría de plan"),
    durationType: z.string().min(1, "Selecciona una duración"),
    interval: planIntervalSchema,
    durationDays: z.coerce.number().min(0),
    isCalendarDuration: z.boolean(),
    price: z.coerce.number().min(0, "El precio no puede ser negativo"),
    active: z.boolean(),
    createsSubscription: z.boolean(),
    registersAccessOnSale: z.boolean(),
    classCount: z.coerce.number().int().min(1, "Mínimo 1 clase").optional(),
    requiredTagPublicIds: z.array(z.string()),
  })
  .refine((data) => data.durationType !== "CUSTOM" || data.durationDays >= 1, {
    message: "La duración debe ser mayor a 0",
    path: ["durationDays"],
  });

export type PlanFormInput = z.input<typeof planFormSchema>;
export type PlanFormValues = z.infer<typeof planFormSchema>;
